import teamService from './team.service';

const teamScopingService = {
  async teamsCallback() {
    const sortedTeams = await teamService.getAllMyTeams();

    return { sortedTeams, allTeamsWithMultiTeamEnabled: [] };
  },
};

export default teamScopingService;
